import styled from 'styled-components';

export const Icon = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: ${({ logo_url }) => `url(${logo_url})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-color: white;
  background-position: center center;
  overflow: hidden;
  cursor: pointer;
  vertical-align: bottom;
  margin-right: 3px;
`;
